// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { FaEye, FaEdit } from "react-icons/fa";
// import { BsThreeDots } from "react-icons/bs";
// import {
//   MdAirplanemodeInactive,
//   MdAirplanemodeActive,
//   MdOutlineUpcoming,
//   MdUpcoming,
// } from "react-icons/md";
// import { RiDeleteBin5Fill } from "react-icons/ri";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// import * as XLSX from "xlsx";
// import { FaDownload } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;
// const allowedDomains = [
//   "rajasthanirealestates.in",
//   "realestate.a2logicgroup.com",
//   "master.bahikhatas.com"
// ];

// const dontallowedDomains = ["master.bahikhatas.com"];

// const currentDomain = window.location.host;

// function AllPlotList() {
//   const [plots, setPlots] = useState([]);
//   const [exporting, setExporting] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchInput, setSearchInput] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedPlot, setSelectedPlot] = useState(null);
//   const [limit, setLimit] = useState(10);
//   const [projects, setProjects] = useState([]);
//   const [selectedProject, setSelectedProject] = useState("");
//   const [editFormData, setEditFormData] = useState({
//     plot_id: "",
//     project_id: "",
//     project_name: "",
//     block_id: "",
//     block_name: "",
//     property_type: "",
//     plot_shop_villa_no: "",
//     plot_size: "",
//     plot_sqyd: "",
//     plot_rate: "",
//     resgistry_patta: "",
//     resgistry_date: "",
//     plot_hold: "",
//     plot_address: "",
//     status: "",
//   });

//   const [projectsForEdit, setProjectsForEdit] = useState([]);
//   const [blocksForEdit, setBlocksForEdit] = useState([]);
//   const [loadingDropdowns, setLoadingDropdowns] = useState(false);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const [isFilterActive, setIsFilterActive] = useState(false);

//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   useEffect(() => {
//     const fetchProjectsListForEdit = async () => {
//       setLoadingDropdowns(true);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const response = await fetch(`${API_URL}/project-list-block`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           showCustomMessageModal(
//             "Error",
//             errorData.message || "Failed to fetch projects for dropdown.",
//             "error",
//           );
//           setLoadingDropdowns(false);
//           return;
//         }

//         const data = await response.json();
//         setProjectsForEdit(data.data || []);
//       } catch (err) {
//         console.error("Fetch projects for edit error:", err);
//         showCustomMessageModal(
//           "Error",
//           err.message ||
//           "An unexpected error occurred while fetching projects for edit.",
//           "error",
//         );
//       } finally {
//         setLoadingDropdowns(false);
//       }
//     };

//     fetchProjectsListForEdit();
//   }, []);

//   useEffect(() => {
//     const fetchBlocksListForEdit = async () => {
//       if (editFormData.project_id) {
//         setLoadingDropdowns(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             setLoadingDropdowns(false);
//             return;
//           }

//           const response = await fetch(`${API_URL}/block-list-plot`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ project_id: editFormData.project_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch blocks for dropdown.",
//               "error",
//             );
//             setBlocksForEdit([]);
//             setLoadingDropdowns(false);
//             return;
//           }

//           const data = await response.json();
//           setBlocksForEdit(data.data || []);
//         } catch (err) {
//           console.error("Fetch blocks for edit error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//             "An unexpected error occurred while fetching blocks for edit.",
//             "error",
//           );
//           setBlocksForEdit([]);
//         } finally {
//           setLoadingDropdowns(false);
//         }
//       } else {
//         setBlocksForEdit([]);
//       }
//     };

//     fetchBlocksListForEdit();
//   }, [editFormData.project_id]);

//   const fetchPlots = async (page = 1, query = "", projectFilter = "") => {
//     setError(null);
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const url = new URL(`${API_URL}/plot-list`);
//       url.searchParams.append("page", page);
//       url.searchParams.append("limit", limit);

//       // Add unit no search
//       if (query) {
//         url.searchParams.append("plot_shop_villa_no", query);
//       }

//       // Add project filter
//       if (projectFilter) {
//         url.searchParams.append("project_name", projectFilter);
//       }

//       const response = await fetch(url.toString(), {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error",
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch Units.");
//       }

//       const data = await response.json();
//       setPlots(data.data || []);
//       setTotalPages(data.totalPages || 1);
//       setCurrentPage(data.currentPage || page);
//     } catch (err) {
//       console.error("Fetch Units error:", err);
//       setError(err.message);
//       if (!showMessageModal) {
//         showCustomMessageModal(
//           "Error",
//           err.message || "An unexpected error occurred while fetching Units.",
//           "error",
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPlots(currentPage, searchQuery, selectedProject);
//   }, [currentPage, searchQuery, selectedProject]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleSearchChange = (e) => {
//     setSearchInput(e.target.value);
//   };

//   const handleSearchSubmit = () => {
//     setSearchQuery(searchInput);
//     setCurrentPage(1);
//   };

//   const handleProjectFilterChange = (e) => {
//     setSelectedProject(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleClearFilters = () => {
//     setSearchInput("");
//     setSearchQuery("");
//     setSelectedProject("");
//     setCurrentPage(1);
//   };

//   const handleViewPlot = async (plotId) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/plot-view`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: plotId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch unit details.");
//       }

//       const data = await response.json();
//       setSelectedPlot(data.data);
//       setShowViewModal(true);
//     } catch (err) {
//       console.error("View Units error:", err);
//       setError(err.message);
//       showCustomMessageModal(
//         "Error",
//         err.message ||
//         "An unexpected error occurred while fetching unit details.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditPlot = async (plotId) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const response = await fetch(`${API_URL}/plot-edit`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ id: plotId }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(
//           errorData.message || "Failed to fetch Units for editing.",
//         );
//       }

//       const data = await response.json();
//       const plotData = data.data;
//       setSelectedPlot(plotData);

//       setEditFormData({
//         plot_id: plotData.id || "",
//         project_id: plotData.project_id || "",
//         project_name: plotData.project_name || "",
//         block_id: plotData.block_id || "",
//         block_name: plotData.block_name || "",
//         plot_shop_villa_no: plotData.plot_shop_villa_no || "",
//         plot_size: plotData.dimension || "",
//         plot_sqyd: plotData.area_sqyd || "",
//         plot_rate: plotData.rate || "",
//         resgistry_patta: plotData.document_type || "",
//         plot_address: plotData.address || "",
//         status: plotData.status || "Available",
//       });
//       setShowEditModal(true);
//     } catch (err) {
//       console.error("Edit plot error:", err);
//       setError(err.message);
//       showCustomMessageModal(
//         "Error",
//         err.message ||
//         "An unexpected error occurred while fetching Units for editing.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;

//     setEditFormData((prevData) => {
//       const newData = { ...prevData, [name]: value };

//       if (name === "project_id") {
//         const selectedProjectObj = projectsForEdit.find(
//           (proj) => proj.id.toString() === value,
//         );
//         newData.project_name = selectedProjectObj
//           ? selectedProjectObj.name
//           : "";
//         newData.block_id = "";
//         newData.block_name = "";
//         setBlocksForEdit([]);
//       } else if (name === "block_id") {
//         const selectedBlockObj = blocksForEdit.find(
//           (block) => block.id.toString() === value,
//         );
//         newData.block_name = selectedBlockObj ? selectedBlockObj.name : "";
//       }
//       return newData;
//     });
//   };

//   const handleUpdatePlot = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         return;
//       }

//       const payload = {
//         plot_id: editFormData.plot_id,
//         project_id: editFormData.project_id,
//         project_name: editFormData.project_name,
//         block_id: editFormData.block_id,
//         block_name: editFormData.block_name,
//         plot_shop_villa_no: editFormData.plot_shop_villa_no,
//         dimension: parseFloat(editFormData.plot_size),
//         area_sqyd: parseFloat(editFormData.plot_sqyd),
//         rate: parseFloat(editFormData.plot_rate),
//         document_type: editFormData.resgistry_patta,
//         address: editFormData.plot_address,
//         status: editFormData.status,
//       };

//       const response = await fetch(`${API_URL}/plot-update`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update Units.");
//       }
//       const result = await response.json();
//       if (result.success == "1") {
//         showCustomMessageModal(
//           "Success",
//           "Units updated successfully!",
//           "success",
//         );
//         setShowEditModal(false);
//         fetchPlots(currentPage, searchQuery, selectedProject);
//       }
//     } catch (err) {
//       console.error("Update plot error:", err);
//       setError(err.message);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An unexpected error occurred while updating Units.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusUpdate = async (plotId, currentStatus) => {
//     const newStatus = currentStatus === "available" ? "sold" : "available";
//     showCustomMessageModal(
//       "Confirm Status Change",
//       `Do you want to change the status to ${newStatus}?`,
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             return;
//           }

//           const response = await fetch(`${API_URL}/plot-status-update`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: plotId, status: newStatus }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(
//               errorData.message || "Failed to update Units status.",
//             );
//           }

//           const result = await response.json();

//           if (result.success == "1") {
//             showCustomMessageModal(
//               "Success",
//               "Units status updated successfully!",
//               "success",
//             );
//             fetchPlots(currentPage, searchQuery, selectedProject);
//           }
//         } catch (err) {
//           console.error("Status update error:", err);
//           setError(err.message);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//             "An unexpected error occurred while updating plot status.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//         }
//       },
//     );
//   };

//   const handleDeletePlot = async (plotId) => {
//     showCustomMessageModal(
//       "Confirm Deletion",
//       "Are you sure you want to delete this Units? This action cannot be undone.",
//       "warning",
//       async () => {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error",
//             );
//             return;
//           }

//           const response = await fetch(`${API_URL}/plot-delete`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ id: plotId }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to delete Units.");
//           }

//           showCustomMessageModal(
//             "Success",
//             "Units deleted successfully!",
//             "success",
//           );
//           fetchPlots(currentPage, searchQuery, selectedProject);
//         } catch (err) {
//           console.error("Delete Units error:", err);
//           setError(err.message);
//           showCustomMessageModal(
//             "Error",
//             err.message || "An unexpected error occurred while deleting Units.",
//             "error",
//           );
//         } finally {
//           setLoading(false);
//         }
//       },
//     );
//   };

//   const handleCloseViewModal = () => {
//     setShowViewModal(false);
//     setSelectedPlot(null);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedPlot(null);
//     setEditFormData({
//       plot_id: "",
//       project_id: "",
//       project_name: "",
//       block_id: "",
//       block_name: "",
//       property_type: "",
//       plot_shop_villa_no: "",
//       plot_size: "",
//       plot_sqyd: "",
//       plot_rate: "",
//       resgistry_patta: "",
//       resgistry_date: "",
//       plot_hold: "",
//       plot_address: "",
//       status: "",
//     });
//     setBlocksForEdit([]);
//   };

//   const exportAllToExcel = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         alert("Please login!");
//         return;
//       }
//       let url = `${API_URL}/plot-excel-download`;
//       const params = new URLSearchParams();

//       if (searchQuery.trim() !== "") {
//         params.append("plot_shop_villa_no", searchQuery);
//       }

//       if (selectedProject.trim() !== "") {
//         params.append("project_name", selectedProject);
//       }

//       const queryString = params.toString();
//       if (queryString) {
//         url += `?${queryString}`;
//       }

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "text/csv",
//         },
//       });

//       if (!response.ok) {
//         alert("Server Error: Unable to download!");
//         return;
//       }

//       let filename = `unit${Date.now()}.csv`;
//       if (selectedProject.trim() !== "") {
//         const cleanProjectName = selectedProject.replace(/[^a-zA-Z0-9]/g, "_");
//         filename = `unit_${cleanProjectName}_${Date.now()}.csv`;
//       }

//       const csvData = await response.text();
//       const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.setAttribute("download", filename);
//       link.click();

//       showCustomMessageModal(
//         "Success",
//         selectedProject
//           ? `Data exported successfully for project: ${selectedProject}`
//           : "All units data exported successfully",
//         "success",
//       );
//     } catch (error) {
//       console.error("CSV Export Error:", error);
//       alert("Export Failed! Try again");
//     }
//   };

//   const fetchProjects = async () => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/project-list-block`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setProjects(data.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching projects:", error);
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ minHeight: "80vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="alert alert-danger text-center m-5" role="alert">
//         {error}
//         <button className="btn btn-primary ms-3" onClick={() => fetchPlots()}>
//           Retry
//         </button>
//       </div>
//     );
//   }

//   // return (
//   //   <div className="userlist mt-2">
//   //     <div className="card">
//   //       <div className="card-header">
//   //         <div className="d-flex align-items-center justify-content-between flex-wrap-mobile gap-2">
//   //           <div className="titlepage">
//   //             <h3>All Unit List</h3>
//   //           </div>
//   //           <div className="d-flex gap-2 align-items-center">
              
//   //               <div className="createnewadmin">
//   //                 <button
//   //                   className="exportexcel btn gap-2 btn-success d-inline-flex align-items-center"
//   //                   onClick={exportAllToExcel}
//   //                   disabled={exporting}
//   //                 >
//   //                   <FaDownload />
//   //                   {exporting ? (
//   //                     <>
//   //                       <span
//   //                         className="spinner-border spinner-border-sm me-2"
//   //                         role="status"
//   //                         aria-hidden="true"
//   //                       ></span>
//   //                       Exporting...
//   //                     </>
//   //                   ) : (
//   //                     `Export`
//   //                   )}
//   //                 </button>
//   //               </div>
//   //             <div className="createnewadmin">
//   //               <Link
//   //                 to="/create-plot-manual"
//   //                 className="btn btn-success d-flex align-items-center"
//   //               >
//   //                 <FaPlus className="me-2" /> Manual Add
//   //               </Link>
//   //             </div>

//   //             <div className="createnewadmin">
//   //               <Link
//   //                 to="/create-plot"
//   //                 className="btn btn-success d-flex align-items-center"
//   //               >
//   //                 <FaPlus className="me-2" /> Upload CSV
//   //               </Link>
//   //             </div>
//   //             <div className="d-flex gap-2">
//   //               <button
//   //                 className={`filter-toggle-btn btn border boder-1 ${isFilterActive ? "active" : ""}`}
//   //                 onClick={handleToggle}
//   //               >
//   //                 {isFilterActive ? (
//   //                   <>
//   //                     <MdFilterAltOff />
//   //                   </>
//   //                 ) : (
//   //                   <>
//   //                     <MdFilterAlt />
//   //                   </>
//   //                 )}
//   //               </button>
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>

//   //       <div className="card-body">
//   //         {isFilterActive && (
//   //           <div className="d-flex gap-2 mb-3 mt-2 flex-wrap-mobile">
//   //             <Form.Group
//   //               controlId="projectFilterMobile"
//   //               className="flex-grow-1"
//   //             >
//   //               <Form.Select
//   //                 value={selectedProject}
//   //                 onChange={handleProjectFilterChange}
//   //                 style={{ minWidth: "180px" }}
//   //               >
//   //                 <option value="">All Projects</option>
//   //                 {projects.map((project) => (
//   //                   <option key={project.id} value={project.name}>
//   //                     {project.name}
//   //                   </option>
//   //                 ))}
//   //               </Form.Select>
//   //             </Form.Group>

//   //             <Form.Group
//   //               controlId="searchPlotMobile"
//   //               className="d-flex flex-grow-1"
//   //             >
//   //               <input
//   //                 type="text"
//   //                 placeholder="Search by Unit No."
//   //                 value={searchInput}
//   //                 onChange={handleSearchChange}
//   //                 className="form-control"
//   //               />
//   //               <button
//   //                 type="button"
//   //                 className="btn btn-primary ms-2"
//   //                 onClick={handleSearchSubmit}
//   //               >
//   //                 Search
//   //               </button>
//   //             </Form.Group>

//   //             {(searchQuery || selectedProject) && (
//   //               <button
//   //                 type="button"
//   //                 className="btn btn-secondary"
//   //                 onClick={handleClearFilters}
//   //               >
//   //                 Clear Filters
//   //               </button>
//   //             )}
//   //           </div>
//   //         )}

//   //         <div className="table-responsive">
//   //           <Table bordered>
//   //             <thead className="bg-primary text-white">
//   //               <tr>
//   //                 <th>ID</th>
//   //                 <th>Project Name</th>
//   //                 <th>Block Name</th>
//   //                 <th>Unit No.</th>
//   //                 <th>Road Size</th>
//   //                 <th>Unit Type (Corner/Normal)</th>
//   //                 <th>Facing</th>
//   //                 <th>Unit Size</th>
//   //                 <th>Unit Area SQMT</th>
//   //                 <th>Unit Area(SQYD)</th>
//   //                 <th>PLC (%)</th>
//   //                 <th>Unit Rate(Per SQYd Rate)</th>
//   //                 <th>Unit Price</th>
//   //                 <th>Date</th>
//   //                 <th>Status</th>
//   //                 <th>Actions</th>
//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {plots?.length > 0 ? (
//   //                 plots.map((plot, index) => (
//   //                   <tr key={plot.id}>
//   //                     <td>{(currentPage - 1) * limit + (index + 1)}</td>
//   //                     <td>{plot.project_name}</td>
//   //                     <td>{plot.block_name}</td>
//   //                     <td>{plot.plot_shop_villa_no}</td>
//   //                     <td>{plot.road_size || "NA"}</td>
//   //                     <td>{plot.unit_type || "NA"}</td>
//   //                     <td>{plot.facing || "NA"}</td>
//   //                     <td>{plot.dimension || "0.00"}</td>
//   //                     <td>{plot.unit_area_sqmt || "0.00"}</td>
//   //                     <td>{plot.area_sqyd || "0.00"}</td>
//   //                     <td>{plot.plc_percentage || "0.00"}</td>
//   //                     <td>{plot.rate || "0.00"}</td>
//   //                     <td>{plot.unit_price || "0.00"}</td>
//   //                     <td>
//   //                       {plot.date
//   //                         ? (() => {
//   //                           const [day, month, year] = plot.date.split("-");
//   //                           const formattedDate = new Date(`${year}-${month}-${day}`);
//   //                           return !isNaN(formattedDate)
//   //                             ? formattedDate.toLocaleDateString("en-GB")
//   //                             : "NA";
//   //                         })()
//   //                         : "NA"}
//   //                     </td>
//   //                     <td>
//   //                       <span
//   //                         className={`badge ${plot.status === "available"
//   //                             ? "bg-success"
//   //                             : "bg-danger"
//   //                           }`}
//   //                       >
//   //                         {plot.status}
//   //                       </span>
//   //                     </td>
//   //                     <td>
//   //                       <div className="dropdown">
//   //                         <button
//   //                           className="btn light btn-action dropdown-toggle"
//   //                           type="button"
//   //                           id="dropdownMenuButton"
//   //                           data-bs-toggle="dropdown"
//   //                           aria-expanded="false"
//   //                         >
//   //                           <BsThreeDots size={20} />
//   //                         </button>
//   //                         <ul
//   //                           className="dropdown-menu"
//   //                           aria-labelledby="dropdownMenuButton"
//   //                         >
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn view_btn btn-sm me-1"
//   //                               onClick={() => handleViewPlot(plot.id)}
//   //                               title="View Project Details"
//   //                             >
//   //                               <FaEye /> View
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn edit_btn btn-sm me-1"
//   //                               onClick={() => handleEditPlot(plot.id)}
//   //                               title="Edit Project"
//   //                             >
//   //                               <FaEdit /> Edit
//   //                             </button>
//   //                           </li>
//   //                           <li className="dropdown-item">
//   //                             <Button
//   //                               size="sm"
//   //                               variant={
//   //                                 plot.status === "available"
//   //                                   ? "danger"
//   //                                   : "success"
//   //                               }
//   //                               className="btn btn-danger btn-sm"
//   //                               onClick={() =>
//   //                                 handleStatusUpdate(plot.id, plot.status)
//   //                               }
//   //                             >
//   //                               {plot.status === "available" ? (
//   //                                 <MdAirplanemodeInactive />
//   //                               ) : (
//   //                                 <MdAirplanemodeActive />
//   //                               )}
//   //                               {plot.status === "available"
//   //                                 ? "Sold"
//   //                                 : "Available"}
//   //                             </Button>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn delete_btn btn-sm"
//   //                               onClick={() => handleDeletePlot(plot.id)}
//   //                               title="Delete Project"
//   //                             >
//   //                               <RiDeleteBin5Fill /> Delete
//   //                             </button>
//   //                           </li>
//   //                         </ul>
//   //                       </div>
//   //                     </td>
//   //                   </tr>
//   //                 ))
//   //               ) : (
//   //                 <tr>
//   //                   <td colSpan="16" className="text-center">
//   //                     {searchQuery || selectedProject
//   //                       ? "No units found with current filters."
//   //                       : "No units found."}
//   //                   </td>
//   //                 </tr>
//   //               )}
//   //             </tbody>
//   //           </Table>
//   //         </div>

//   //         <div className="d-flex justify-content-end">
//   //           <Pagination>
//   //             <Pagination.Prev
//   //               onClick={() => handlePageChange(currentPage - 1)}
//   //               disabled={currentPage === 1}
//   //             />

//   //             {/* Always show first page */}
//   //             <Pagination.Item
//   //               active={1 === currentPage}
//   //               onClick={() => handlePageChange(1)}
//   //             >
//   //               1
//   //             </Pagination.Item>

//   //             {/* Show ellipsis if there are pages before current page beyond page 2 */}
//   //             {currentPage > 3 && <Pagination.Ellipsis />}

//   //             {/* Show pages around current page */}
//   //             {[...Array(totalPages)].map((_, index) => {
//   //               const pageNumber = index + 1;
//   //               // Show page if it's within 1 of current page (except page 1 which is always shown)
//   //               if (
//   //                 pageNumber > 1 &&
//   //                 pageNumber < totalPages &&
//   //                 Math.abs(pageNumber - currentPage) <= 1
//   //               ) {
//   //                 return (
//   //                   <Pagination.Item
//   //                     key={pageNumber}
//   //                     active={pageNumber === currentPage}
//   //                     onClick={() => handlePageChange(pageNumber)}
//   //                   >
//   //                     {pageNumber}
//   //                   </Pagination.Item>
//   //                 );
//   //               }
//   //               return null;
//   //             })}

//   //             {/* Show ellipsis if there are pages after current page before last page */}
//   //             {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

//   //             {/* Always show last page if there's more than 1 page */}
//   //             {totalPages > 1 && (
//   //               <Pagination.Item
//   //                 active={totalPages === currentPage}
//   //                 onClick={() => handlePageChange(totalPages)}
//   //               >
//   //                 {totalPages}
//   //               </Pagination.Item>
//   //             )}

//   //             <Pagination.Next
//   //               onClick={() => handlePageChange(currentPage + 1)}
//   //               disabled={currentPage === totalPages}
//   //             />
//   //           </Pagination>
//   //         </div>
//   //       </div>
//   //     </div>

//   //     {/* View Plot Modal */}
//   //     <Modal
//   //       show={showViewModal}
//   //       onHide={handleCloseViewModal}
//   //       centered
//   //       size="lg"
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Unit Details</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         {selectedPlot && (
//   //           <div className="table-responsive">
//   //             <table className="table mb-0">
//   //               <tbody>
//   //                 <tr>
//   //                   <th>Project Name</th>
//   //                   <td>{selectedPlot.project_name}</td>
//   //                   <th>Block Name</th>
//   //                   <td>{selectedPlot.block_name}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Unit No.</th>
//   //                   <td>{selectedPlot.plot_shop_villa_no}</td>
//   //                   <th>Road Size</th>
//   //                   <td>{selectedPlot.road_size}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Unit Type (Corner/Normal)</th>
//   //                   <td>{selectedPlot.unit_type}</td>
//   //                   <th>Facing</th>
//   //                   <td>{selectedPlot.facing}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Unit Size</th>
//   //                   <td>{selectedPlot.dimension}</td>
//   //                   <th>Unit Area SQMT</th>
//   //                   <td>{selectedPlot.unit_area_sqmt}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Unit Area(SQYD)</th>
//   //                   <td>{selectedPlot.area_sqyd}</td>
//   //                   <th>PLC Percentage</th>
//   //                   <td>{selectedPlot.plc_percentage}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Unit Rate(Per SQYd Rate)</th>
//   //                   <td>{selectedPlot.rate}</td>
//   //                   <th>Unit Price</th>
//   //                   <td>{selectedPlot.unit_price}</td>
//   //                 </tr>

//   //                 <tr>
//   //                   <th>Date</th>
//   //                   <td>
//   //                     {selectedPlot.date &&
//   //                       !isNaN(new Date(selectedPlot.date).getTime())
//   //                       ? new Date(selectedPlot.date).toLocaleDateString(
//   //                         "en-GB",
//   //                       )
//   //                       : "NA"}
//   //                   </td>

//   //                   <th>Status</th>
//   //                   <td>
//   //                     <span
//   //                       className={`badge ${selectedPlot.status === "available"
//   //                           ? "bg-success"
//   //                           : "bg-danger"
//   //                         }`}
//   //                     >
//   //                       {selectedPlot.status}
//   //                     </span>
//   //                   </td>
//   //                 </tr>
//   //               </tbody>
//   //             </table>
//   //           </div>
//   //         )}
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="danger" onClick={handleCloseViewModal}>
//   //           Close
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {/* Edit Plot Modal */}
//   //     <Modal
//   //       show={showEditModal}
//   //       size="lg"
//   //       onHide={handleCloseEditModal}
//   //       centered
//   //     >
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Unit</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         <Form onSubmit={handleUpdatePlot}>
//   //           <div className="row">
//   //             <div className="col-md-6">
//   //               <Form.Group className="mb-3" controlId="editProjectId">
//   //                 <Form.Label>Project Name</Form.Label>
//   //                 <Form.Select
//   //                   name="project_id"
//   //                   value={editFormData.project_id}
//   //                   onChange={handleEditFormChange}
//   //                   disabled={loadingDropdowns || projectsForEdit.length === 0}
//   //                   required
//   //                 >
//   //                   <option value="">Select a Project</option>
//   //                   {projectsForEdit.map((project) => (
//   //                     <option key={project.id} value={project.id}>
//   //                       {project.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Select>
//   //                 {loadingDropdowns && projectsForEdit.length === 0 && (
//   //                   <small className="text-muted">Loading projects...</small>
//   //                 )}
//   //                 {!loadingDropdowns && projectsForEdit.length === 0 && (
//   //                   <small className="text-danger">
//   //                     No projects available.
//   //                   </small>
//   //                 )}
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editBlockId">
//   //                 <Form.Label>Block Name</Form.Label>
//   //                 <Form.Select
//   //                   name="block_id"
//   //                   value={editFormData.block_id}
//   //                   onChange={handleEditFormChange}
//   //                   disabled={
//   //                     !editFormData.project_id ||
//   //                     loadingDropdowns ||
//   //                     blocksForEdit.length === 0
//   //                   }
                    
//   //                 >
//   //                   <option value="">Select a Block</option>
//   //                   {blocksForEdit.map((block) => (
//   //                     <option key={block.id} value={block.id}>
//   //                       {block.name}
//   //                     </option>
//   //                   ))}
//   //                 </Form.Select>
//   //                 {editFormData.project_id &&
//   //                   loadingDropdowns &&
//   //                   blocksForEdit.length === 0 && (
//   //                     <small className="text-muted">Loading blocks...</small>
//   //                   )}
//   //                 {editFormData.project_id &&
//   //                   !loadingDropdowns &&
//   //                   blocksForEdit.length === 0 && (
//   //                     <small className="text-danger">
//   //                       No blocks available for this project.
//   //                     </small>
//   //                   )}
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="displayProjectName">
//   //                 <Form.Label>Selected Project Name</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="project_name"
//   //                   value={editFormData.project_name}
//   //                   readOnly
//   //                   disabled
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="displayBlockName">
//   //                 <Form.Label>Selected Block Name</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="block_name"
//   //                   value={editFormData.block_name}
//   //                   readOnly
//   //                   disabled
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editPlotShopVillaNo">
//   //                 <Form.Label>Unit/Shop/Villa No.</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="plot_shop_villa_no"
//   //                   value={editFormData.plot_shop_villa_no}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editPlotSize">
//   //                 <Form.Label>Dimension</Form.Label>
//   //                 <Form.Control
//   //                   type="text"
//   //                   name="plot_size"
//   //                   value={editFormData.plot_size}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               <Form.Group className="mb-3" controlId="editPlotSqYd">
//   //                 <Form.Label>Area Sq. yard.</Form.Label>
//   //                 <Form.Control
//   //                   type="number"
//   //                   name="plot_sqyd"
//   //                   value={editFormData.plot_sqyd}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                   min="0"
//   //                   step="0.01"
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editPlotRate">
//   //                 <Form.Label>Rate</Form.Label>
//   //                 <Form.Control
//   //                   type="number"
//   //                   name="plot_rate"
//   //                   value={editFormData.plot_rate}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                   min="0"
//   //                   step="0.01"
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editResgistryPatta">
//   //                 <Form.Label>Document Type</Form.Label>
//   //                 <Form.Select
//   //                   name="resgistry_patta"
//   //                   value={editFormData.resgistry_patta}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 >
//   //                   <option value="">Select Option</option>
//   //                   <option value="registry">Registry</option>
//   //                   <option value="patta">Patta</option>
//   //                   <option value="registrywithpatta">
//   //                     Registry with Patta
//   //                   </option>
//   //                 </Form.Select>
//   //               </Form.Group>
//   //             </div>

//   //             <div className="col-md-6">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editStatus">
//   //                 <Form.Label>Status</Form.Label>
//   //                 <Form.Select
//   //                   name="status"
//   //                   value={editFormData.status}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 >
//   //                   <option value="available">Available</option>
//   //                   <option value="sold">Sold</option>
//   //                 </Form.Select>
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-12">
//   //               {" "}
//   //               <Form.Group className="mb-3" controlId="editPlotAddress">
//   //                 <Form.Label>Address</Form.Label>
//   //                 <Form.Control
//   //                   as="textarea"
//   //                   rows={3}
//   //                   name="plot_address"
//   //                   value={editFormData.plot_address}
//   //                   onChange={handleEditFormChange}
//   //                   required
//   //                 />
//   //               </Form.Group>
//   //             </div>
//   //             <div className="col-md-12">
//   //               <div className="d-flex justify-content-end">
//   //                 <Button
//   //                   variant="primary"
//   //                   type="submit"
//   //                   className="w-100"
//   //                   disabled={loading}
//   //                 >
//   //                   {loading ? "Updating..." : "Update Unit"}
//   //                 </Button>
//   //               </div>
//   //             </div>
//   //           </div>
//   //         </Form>
//   //       </Modal.Body>
//   //     </Modal>

//   //     {/* Custom Message Modal */}
//   //     {showMessageModal && (
//   //       <div
//   //         className="modal d-block"
//   //         tabIndex="-1"
//   //         style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//   //       >
//   //         <div className="modal-dialog modal-dialog-centered">
//   //           <div
//   //             className={`modal-content ${messageModalContent.type === "success" ? "" : messageModalContent.type === "error" ? "" : ""}`}
//   //           >
//   //             <div className="modal-header d-flex justify-content-between align-items-center">
//   //               <h5
//   //                 className={`modal-title ${messageModalContent.type === "success" ? "text-white" : messageModalContent.type === "error" ? "text-white" : "text-white"}`}
//   //               >
//   //                 {messageModalContent.title}
//   //               </h5>
//   //               <button
//   //                 type="button"
//   //                 className="btn-close"
//   //                 aria-label="Close"
//   //                 onClick={closeCustomMessageModal}
//   //               ></button>
//   //             </div>
//   //             <div className="modal-body text-secondary">
//   //               <p>{messageModalContent.text}</p>
//   //             </div>
//   //             <div className="modal-footer justify-content-center">
//   //               {messageModalContent.confirmAction ? (
//   //                 <>
//   //                   <Button
//   //                     variant={
//   //                       messageModalContent.type === "btn-primary-custum"
//   //                         ? "btn-primary-custum"
//   //                         : "primary"
//   //                     }
//   //                     onClick={() => {
//   //                       messageModalContent.confirmAction();
//   //                       closeCustomMessageModal();
//   //                     }}
//   //                   >
//   //                     Confirm
//   //                   </Button>
//   //                   <Button variant="danger" onClick={closeCustomMessageModal}>
//   //                     Cancel
//   //                   </Button>
//   //                 </>
//   //               ) : (
//   //                 <Button
//   //                   variant={
//   //                     messageModalContent.type === "btn-primary-custum"
//   //                       ? "btn-primary-custum"
//   //                       : messageModalContent.type === "error"
//   //                         ? "danger"
//   //                         : "primary"
//   //                   }
//   //                   onClick={closeCustomMessageModal}
//   //                 >
//   //                   OK
//   //                 </Button>
//   //               )}
//   //             </div>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     )}
//   //   </div>
//   // );
// return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏢
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 All Unit List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all your units here
//               </p>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 flexWrap: "wrap",
//                 alignItems: "center",
//               }}
//             >
//               <button
//                 onClick={exportAllToExcel}
//                 disabled={exporting}
//                 style={{
//                   padding: "12px 20px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   cursor: exporting ? "not-allowed" : "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaDownload />
//                 {exporting ? "Exporting..." : "Export"}
//               </button>

//               <Link
//                 to="/create-plot-manual"
//                 style={{
//                   padding: "12px 20px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaPlus /> Manual Add
//               </Link>

//               <Link
//                 to="/create-plot"
//                 style={{
//                   padding: "12px 20px",
//                   borderRadius: "12px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   textDecoration: "none",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   boxShadow: "0 8px 24px rgba(30, 87, 153, 0.3)",
//                 }}
//               >
//                 <FaPlus /> Upload CSV
//               </Link>

//               <button
//                 onClick={handleToggle}
//                 style={{
//                   padding: "12px 16px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   fontSize: "16px",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//                 title="Toggle Filters"
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "24px" }}>
//               {/* 🎯 FILTERS */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     marginBottom: "20px",
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <Form.Select
//                     value={selectedProject}
//                     onChange={handleProjectFilterChange}
//                     style={{
//                       minWidth: "200px",
//                       flex: 1,
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1.5px solid #e2e8f0",
//                     }}
//                   >
//                     <option value="">All Projects</option>
//                     {projects.map((project) => (
//                       <option key={project.id} value={project.name}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </Form.Select>

//                   <div style={{ display: "flex", flex: 1, minWidth: "260px" }}>
//                     <input
//                       type="text"
//                       placeholder="Search by Unit No."
//                       value={searchInput}
//                       onChange={handleSearchChange}
//                       style={{
//                         flex: 1,
//                         padding: "10px 14px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         outline: "none",
//                       }}
//                     />
//                     <button
//                       type="button"
//                       onClick={handleSearchSubmit}
//                       style={{
//                         marginLeft: "10px",
//                         padding: "10px 20px",
//                         borderRadius: "10px",
//                         border: "none",
//                         background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                         color: "#ffffff",
//                         fontWeight: "700",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Search
//                     </button>
//                   </div>

//                   {(searchQuery || selectedProject) && (
//                     <button
//                       type="button"
//                       onClick={handleClearFilters}
//                       style={{
//                         padding: "10px 20px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#f8fafc",
//                         color: "#1e3a5f",
//                         fontWeight: "700",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Clear Filters
//                     </button>
//                   )}
//                 </div>
//               )}

//               <div className="table-responsive">
//                 <Table bordered hover>
//                   <thead
//                     style={{
//                       background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                     }}
//                   >
//                     <tr>
//                       <th>ID</th>
//                       <th>Project Name</th>
//                       <th>Block Name</th>
//                       <th>Unit No.</th>
//                       <th>Road Size</th>
//                       <th>Unit Type</th>
//                       <th>Facing</th>
//                       <th>Unit Size</th>
//                       <th>Unit Area SQMT</th>
//                       <th>Unit Area(SQYD)</th>
//                       <th>PLC (%)</th>
//                       <th>Unit Rate</th>
//                       <th>Unit Price</th>
//                       <th>Date</th>
//                       <th>Status</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {plots?.length > 0 ? (
//                       plots.map((plot, index) => (
//                         <tr key={plot.id}>
//                           <td>{(currentPage - 1) * limit + (index + 1)}</td>
//                           <td>{plot.project_name}</td>
//                           <td>{plot.block_name}</td>
//                           <td>{plot.plot_shop_villa_no}</td>
//                           <td>{plot.road_size || "NA"}</td>
//                           <td>{plot.unit_type || "NA"}</td>
//                           <td>{plot.facing || "NA"}</td>
//                           <td>{plot.dimension || "0.00"}</td>
//                           <td>{plot.unit_area_sqmt || "0.00"}</td>
//                           <td>{plot.area_sqyd || "0.00"}</td>
//                           <td>{plot.plc_percentage || "0.00"}</td>
//                           <td>{plot.rate || "0.00"}</td>
//                           <td>{plot.unit_price || "0.00"}</td>
//                           <td>
//                             {plot.date
//                               ? (() => {
//                                   const [day, month, year] =
//                                     plot.date.split("-");
//                                   const formattedDate = new Date(
//                                     `${year}-${month}-${day}`,
//                                   );
//                                   return !isNaN(formattedDate)
//                                     ? formattedDate.toLocaleDateString("en-GB")
//                                     : "NA";
//                                 })()
//                               : "NA"}
//                           </td>
//                           <td>
//                             <span
//                               className={`badge ${
//                                 plot.status === "available"
//                                   ? "bg-success"
//                                   : "bg-danger"
//                               }`}
//                             >
//                               {plot.status}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id={`dropdownMenuButton-${plot.id}`}
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby={`dropdownMenuButton-${plot.id}`}
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn view_btn btn-sm me-1"
//                                     onClick={() => handleViewPlot(plot.id)}
//                                   >
//                                     <FaEye /> View
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() => handleEditPlot(plot.id)}
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn btn-danger btn-sm"
//                                     onClick={() =>
//                                       handleStatusUpdate(plot.id, plot.status)
//                                     }
//                                   >
//                                     {plot.status === "available" ? (
//                                       <MdAirplanemodeInactive />
//                                     ) : (
//                                       <MdAirplanemodeActive />
//                                     )}
//                                     {plot.status === "available"
//                                       ? "Sold"
//                                       : "Available"}
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn delete_btn btn-sm"
//                                     onClick={() => handleDeletePlot(plot.id)}
//                                   >
//                                     <RiDeleteBin5Fill /> Delete
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="16" className="text-center py-4">
//                           {searchQuery || selectedProject
//                             ? "No units found with current filters."
//                             : "No units found."}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* 🎯 PAGINATION */}
//               <div className="d-flex justify-content-end mt-3">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   <Pagination.Item
//                     active={1 === currentPage}
//                     onClick={() => handlePageChange(1)}
//                   >
//                     1
//                   </Pagination.Item>
//                   {currentPage > 3 && <Pagination.Ellipsis />}
//                   {[...Array(totalPages)].map((_, index) => {
//                     const pageNumber = index + 1;
//                     if (
//                       pageNumber > 1 &&
//                       pageNumber < totalPages &&
//                       Math.abs(pageNumber - currentPage) <= 1
//                     ) {
//                       return (
//                         <Pagination.Item
//                           key={pageNumber}
//                           active={pageNumber === currentPage}
//                           onClick={() => handlePageChange(pageNumber)}
//                         >
//                           {pageNumber}
//                         </Pagination.Item>
//                       );
//                     }
//                     return null;
//                   })}
//                   {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
//                   {totalPages > 1 && (
//                     <Pagination.Item
//                       active={totalPages === currentPage}
//                       onClick={() => handlePageChange(totalPages)}
//                     >
//                       {totalPages}
//                     </Pagination.Item>
//                   )}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 VIEW MODAL */}
//       <Modal
//         show={showViewModal}
//         onHide={handleCloseViewModal}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Unit Details
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedPlot && (
//             <div className="table-responsive">
//               <table className="table mb-0">
//                 <tbody>
//                   <tr>
//                     <th>Project Name</th>
//                     <td>{selectedPlot.project_name}</td>
//                     <th>Block Name</th>
//                     <td>{selectedPlot.block_name}</td>
//                   </tr>
//                   <tr>
//                     <th>Unit No.</th>
//                     <td>{selectedPlot.plot_shop_villa_no}</td>
//                     <th>Road Size</th>
//                     <td>{selectedPlot.road_size}</td>
//                   </tr>
//                   <tr>
//                     <th>Unit Type</th>
//                     <td>{selectedPlot.unit_type}</td>
//                     <th>Facing</th>
//                     <td>{selectedPlot.facing}</td>
//                   </tr>
//                   <tr>
//                     <th>Unit Size</th>
//                     <td>{selectedPlot.dimension}</td>
//                     <th>Unit Area SQMT</th>
//                     <td>{selectedPlot.unit_area_sqmt}</td>
//                   </tr>
//                   <tr>
//                     <th>Unit Area(SQYD)</th>
//                     <td>{selectedPlot.area_sqyd}</td>
//                     <th>PLC Percentage</th>
//                     <td>{selectedPlot.plc_percentage}</td>
//                   </tr>
//                   <tr>
//                     <th>Unit Rate</th>
//                     <td>{selectedPlot.rate}</td>
//                     <th>Unit Price</th>
//                     <td>{selectedPlot.unit_price}</td>
//                   </tr>
//                   <tr>
//                     <th>Date</th>
//                     <td>
//                       {selectedPlot.date &&
//                       !isNaN(new Date(selectedPlot.date).getTime())
//                         ? new Date(selectedPlot.date).toLocaleDateString(
//                             "en-GB",
//                           )
//                         : "NA"}
//                     </td>
//                     <th>Status</th>
//                     <td>
//                       <span
//                         className={`badge ${
//                           selectedPlot.status === "available"
//                             ? "bg-success"
//                             : "bg-danger"
//                         }`}
//                       >
//                         {selectedPlot.status}
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="danger" onClick={handleCloseViewModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 EDIT MODAL */}
//       <Modal
//         show={showEditModal}
//         size="lg"
//         onHide={handleCloseEditModal}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "#1e3a5f", fontWeight: "800" }}>
//             Edit Unit
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdatePlot}>
//             <div className="row">
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editProjectId">
//                   <Form.Label>Project Name</Form.Label>
//                   <Form.Select
//                     name="project_id"
//                     value={editFormData.project_id}
//                     onChange={handleEditFormChange}
//                     disabled={loadingDropdowns || projectsForEdit.length === 0}
//                     required
//                   >
//                     <option value="">Select a Project</option>
//                     {projectsForEdit.map((project) => (
//                       <option key={project.id} value={project.id}>
//                         {project.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editBlockId">
//                   <Form.Label>Block Name</Form.Label>
//                   <Form.Select
//                     name="block_id"
//                     value={editFormData.block_id}
//                     onChange={handleEditFormChange}
//                     disabled={
//                       !editFormData.project_id ||
//                       loadingDropdowns ||
//                       blocksForEdit.length === 0
//                     }
//                   >
//                     <option value="">Select a Block</option>
//                     {blocksForEdit.map((block) => (
//                       <option key={block.id} value={block.id}>
//                         {block.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="displayProjectName">
//                   <Form.Label>Selected Project Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="project_name"
//                     value={editFormData.project_name}
//                     readOnly
//                     disabled
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="displayBlockName">
//                   <Form.Label>Selected Block Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="block_name"
//                     value={editFormData.block_name}
//                     readOnly
//                     disabled
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editPlotShopVillaNo">
//                   <Form.Label>Unit/Shop/Villa No.</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="plot_shop_villa_no"
//                     value={editFormData.plot_shop_villa_no}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editPlotSize">
//                   <Form.Label>Dimension</Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="plot_size"
//                     value={editFormData.plot_size}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editPlotSqYd">
//                   <Form.Label>Area Sq. yard.</Form.Label>
//                   <Form.Control
//                     type="number"
//                     name="plot_sqyd"
//                     value={editFormData.plot_sqyd}
//                     onChange={handleEditFormChange}
//                     required
//                     min="0"
//                     step="0.01"
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editPlotRate">
//                   <Form.Label>Rate</Form.Label>
//                   <Form.Control
//                     type="number"
//                     name="plot_rate"
//                     value={editFormData.plot_rate}
//                     onChange={handleEditFormChange}
//                     required
//                     min="0"
//                     step="0.01"
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editResgistryPatta">
//                   <Form.Label>Document Type</Form.Label>
//                   <Form.Select
//                     name="resgistry_patta"
//                     value={editFormData.resgistry_patta}
//                     onChange={handleEditFormChange}
//                     required
//                   >
//                     <option value="">Select Option</option>
//                     <option value="registry">Registry</option>
//                     <option value="patta">Patta</option>
//                     <option value="registrywithpatta">
//                       Registry with Patta
//                     </option>
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-6">
//                 <Form.Group className="mb-3" controlId="editStatus">
//                   <Form.Label>Status</Form.Label>
//                   <Form.Select
//                     name="status"
//                     value={editFormData.status}
//                     onChange={handleEditFormChange}
//                     required
//                   >
//                     <option value="available">Available</option>
//                     <option value="sold">Sold</option>
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-md-12">
//                 <Form.Group className="mb-3" controlId="editPlotAddress">
//                   <Form.Label>Address</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="plot_address"
//                     value={editFormData.plot_address}
//                     onChange={handleEditFormChange}
//                     required
//                   />
//                 </Form.Group>
//               </div>
//               <div className="col-md-12">
//                 <div className="d-flex justify-content-end">
//                   <Button
//                     variant="primary"
//                     type="submit"
//                     className="w-100"
//                     disabled={loading}
//                   >
//                     {loading ? "Updating..." : "Update Unit"}
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* 🎯 MESSAGE MODAL */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content ${
//                 messageModalContent.type === "success" ? "border-success" : ""
//               }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${
//                     messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                         ? "text-danger"
//                         : "text-warning"
//                   }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                           ? "danger"
//                           : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default AllPlotList;
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaPlus, FaEye, FaEdit, FaDownload } from "react-icons/fa";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import {
  MdAirplanemodeInactive,
  MdAirplanemodeActive,
} from "react-icons/md";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

function AllPlotList() {
  const [plots, setPlots] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // ✅ NEW
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [limit] = useState(LIMIT);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [editFormData, setEditFormData] = useState({
    plot_id: "",
    project_id: "",
    project_name: "",
    block_id: "",
    block_name: "",
    property_type: "",
    plot_shop_villa_no: "",
    plot_size: "",
    plot_sqyd: "",
    plot_rate: "",
    resgistry_patta: "",
    resgistry_date: "",
    plot_hold: "",
    plot_address: "",
    status: "",
  });

  const [projectsForEdit, setProjectsForEdit] = useState([]);
  const [blocksForEdit, setBlocksForEdit] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const [isFilterActive, setIsFilterActive] = useState(false);
  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const getAuthToken = () => localStorage.getItem("token");

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH PROJECTS FOR DROPDOWN
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchProjectsListForEdit = async () => {
      setLoadingDropdowns(true);
      try {
        const token = getAuthToken();
        if (!token) {
          setLoadingDropdowns(false);
          return;
        }

        const response = await fetch(`${API_URL}/project-list-block`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          setLoadingDropdowns(false);
          return;
        }

        const data = await response.json();
        setProjectsForEdit(data.data || []);
      } catch (err) {
        console.error("Fetch projects for edit error:", err);
      } finally {
        setLoadingDropdowns(false);
      }
    };

    fetchProjectsListForEdit();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH BLOCKS WHEN PROJECT CHANGES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchBlocksListForEdit = async () => {
      if (editFormData.project_id) {
        setLoadingDropdowns(true);
        try {
          const token = getAuthToken();
          if (!token) {
            setLoadingDropdowns(false);
            return;
          }

          const response = await fetch(`${API_URL}/block-list-plot`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ project_id: editFormData.project_id }),
          });

          if (!response.ok) {
            setBlocksForEdit([]);
            setLoadingDropdowns(false);
            return;
          }

          const data = await response.json();
          setBlocksForEdit(data.data || []);
        } catch (err) {
          console.error("Fetch blocks for edit error:", err);
          setBlocksForEdit([]);
        } finally {
          setLoadingDropdowns(false);
        }
      } else {
        setBlocksForEdit([]);
      }
    };

    fetchBlocksListForEdit();
  }, [editFormData.project_id]);

  // ═══════════════════════════════════════════
  // 🔹 FETCH PLOTS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchPlots = async (page = 1, query = "", projectFilter = "") => {
    setError(null);
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const url = new URL(`${API_URL}/plot-list`);
      url.searchParams.append("page", page);
      url.searchParams.append("limit", LIMIT);

      if (query) url.searchParams.append("plot_shop_villa_no", query);
      if (projectFilter) url.searchParams.append("project_name", projectFilter);

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch Units.");
      }

      const data = await response.json();
      setPlots(data.data || []);

      // ✅ Server se totalPages aur total dono set karo
      const pages = Number(data.totalPages) || 1;
      const total = Number(data.total) || (data.data?.length || 0);

      setTotalPages(pages);
      setTotalItems(total);
      setCurrentPage(Number(data.currentPage) || Number(page));
    } catch (err) {
      console.error("Fetch Units error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlots(currentPage, searchQuery, selectedProject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchQuery, selectedProject]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => setSearchInput(e.target.value);

  const handleSearchSubmit = () => {
    setSearchQuery(searchInput);
    setCurrentPage(1);
  };

  const handleProjectFilterChange = (e) => {
    setSelectedProject(e.target.value);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setSearchInput("");
    setSearchQuery("");
    setSelectedProject("");
    setCurrentPage(1);
  };

  // ═══════════════════════════════════════════
  // 🔹 VIEW PLOT
  // ═══════════════════════════════════════════
  const handleViewPlot = async (plotId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/plot-view`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: plotId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch unit details.");
      }

      const data = await response.json();
      setSelectedPlot(data.data);
      setShowViewModal(true);
    } catch (err) {
      console.error("View Units error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT PLOT
  // ═══════════════════════════════════════════
  const handleEditPlot = async (plotId) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const response = await fetch(`${API_URL}/plot-edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: plotId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch Units for editing."
        );
      }

      const data = await response.json();
      const plotData = data.data;
      setSelectedPlot(plotData);

      setEditFormData({
        plot_id: plotData.id || "",
        project_id: plotData.project_id || "",
        project_name: plotData.project_name || "",
        block_id: plotData.block_id || "",
        block_name: plotData.block_name || "",
        plot_shop_villa_no: plotData.plot_shop_villa_no || "",
        plot_size: plotData.dimension || "",
        plot_sqyd: plotData.area_sqyd || "",
        plot_rate: plotData.rate || "",
        resgistry_patta: plotData.document_type || "",
        plot_address: plotData.address || "",
        status: plotData.status || "Available",
      });
      setShowEditModal(true);
    } catch (err) {
      console.error("Edit plot error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;

    setEditFormData((prevData) => {
      const newData = { ...prevData, [name]: value };

      if (name === "project_id") {
        const selectedProjectObj = projectsForEdit.find(
          (proj) => proj.id.toString() === value
        );
        newData.project_name = selectedProjectObj
          ? selectedProjectObj.name
          : "";
        newData.block_id = "";
        newData.block_name = "";
        setBlocksForEdit([]);
      } else if (name === "block_id") {
        const selectedBlockObj = blocksForEdit.find(
          (block) => block.id.toString() === value
        );
        newData.block_name = selectedBlockObj ? selectedBlockObj.name : "";
      }
      return newData;
    });
  };

  // ═══════════════════════════════════════════
  // 🔹 UPDATE PLOT
  // ═══════════════════════════════════════════
  const handleUpdatePlot = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      const payload = {
        plot_id: editFormData.plot_id,
        project_id: editFormData.project_id,
        project_name: editFormData.project_name,
        block_id: editFormData.block_id,
        block_name: editFormData.block_name,
        plot_shop_villa_no: editFormData.plot_shop_villa_no,
        dimension: parseFloat(editFormData.plot_size),
        area_sqyd: parseFloat(editFormData.plot_sqyd),
        rate: parseFloat(editFormData.plot_rate),
        document_type: editFormData.resgistry_patta,
        address: editFormData.plot_address,
        status: editFormData.status,
      };

      const response = await fetch(`${API_URL}/plot-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update Units.");
      }
      const result = await response.json();
      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          "Units updated successfully!",
          "success"
        );
        setShowEditModal(false);
        fetchPlots(currentPage, searchQuery, selectedProject);
      }
    } catch (err) {
      console.error("Update plot error:", err);
      showCustomMessageModal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdate = (plotId, currentStatus) => {
    const newStatus = currentStatus === "available" ? "sold" : "available";
    showCustomMessageModal(
      "Confirm Status Change",
      `Do you want to change the status to ${newStatus}?`,
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/plot-status-update`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: plotId, status: newStatus }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update status.");
          }

          const result = await response.json();
          if (result.success == "1") {
            showCustomMessageModal(
              "Success",
              "Units status updated successfully!",
              "success"
            );
            fetchPlots(currentPage, searchQuery, selectedProject);
          }
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE PLOT
  // ═══════════════════════════════════════════
  const handleDeletePlot = (plotId) => {
    showCustomMessageModal(
      "Confirm Deletion",
      "Are you sure you want to delete this Units? This action cannot be undone.",
      "warning",
      async () => {
        setLoading(true);
        try {
          const token = getAuthToken();
          const response = await fetch(`${API_URL}/plot-delete`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ id: plotId }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to delete Units.");
          }

          showCustomMessageModal(
            "Success",
            "Units deleted successfully!",
            "success"
          );
          fetchPlots(currentPage, searchQuery, selectedProject);
        } catch (err) {
          showCustomMessageModal("Error", err.message, "error");
        } finally {
          setLoading(false);
        }
      }
    );
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedPlot(null);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedPlot(null);
    setEditFormData({
      plot_id: "",
      project_id: "",
      project_name: "",
      block_id: "",
      block_name: "",
      property_type: "",
      plot_shop_villa_no: "",
      plot_size: "",
      plot_sqyd: "",
      plot_rate: "",
      resgistry_patta: "",
      resgistry_date: "",
      plot_hold: "",
      plot_address: "",
      status: "",
    });
    setBlocksForEdit([]);
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT CSV
  // ═══════════════════════════════════════════
  const exportAllToExcel = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        alert("Please login!");
        return;
      }
      let url = `${API_URL}/plot-excel-download`;
      const params = new URLSearchParams();

      if (searchQuery.trim() !== "") {
        params.append("plot_shop_villa_no", searchQuery);
      }
      if (selectedProject.trim() !== "") {
        params.append("project_name", selectedProject);
      }

      const queryString = params.toString();
      if (queryString) url += `?${queryString}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/csv",
        },
      });

      if (!response.ok) {
        alert("Server Error: Unable to download!");
        return;
      }

      let filename = `unit${Date.now()}.csv`;
      if (selectedProject.trim() !== "") {
        const cleanProjectName = selectedProject.replace(/[^a-zA-Z0-9]/g, "_");
        filename = `unit_${cleanProjectName}_${Date.now()}.csv`;
      }

      const csvData = await response.text();
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      link.click();

      showCustomMessageModal(
        "Success",
        selectedProject
          ? `Data exported successfully for project: ${selectedProject}`
          : "All units data exported successfully",
        "success"
      );
    } catch (error) {
      console.error("CSV Export Error:", error);
      alert("Export Failed! Try again");
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH PROJECTS FOR FILTER DROPDOWN
  // ═══════════════════════════════════════════
  const fetchProjects = async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/project-list-block`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setProjects(data.data || []);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5" role="alert">
        {error}
        <button className="btn btn-primary ms-3" onClick={() => fetchPlots()}>
          Retry
        </button>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 PAGINATION PAGES GENERATOR
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);

    if (showEllipsis && currentPage > 4) {
      pages.push("left-ellipsis");
    }

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (showEllipsis && currentPage < totalPages - 3) {
      pages.push("right-ellipsis");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                🏢
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  All Plot Lists
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all your plots here ({totalItems} total)
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={exportAllToExcel}
                disabled={exporting}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: exporting ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                }}
              >
                <FaDownload /> {exporting ? "Exporting..." : "Export"}
              </button>

              <Link
                to="/create-plot-manual"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Manual Add
              </Link>

              <Link
                to="/create-plot"
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                }}
              >
                <FaPlus /> Upload CSV
              </Link>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1, minWidth: "220px" }}>
                  <label style={labelStyle}>Project</label>
                  <Form.Select
                    value={selectedProject}
                    onChange={handleProjectFilterChange}
                    style={{
                      width: "100%",
                      padding: "10px 14px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      fontSize: "13.5px",
                      fontWeight: "500",
                    }}
                  >
                    <option value="">All Projects</option>
                    {projects.map((project) => (
                      <option key={project.id} value={project.name}>
                        {project.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>

                <div style={{ flex: 1, minWidth: "260px" }}>
                  <label style={labelStyle}>Unit No.</label>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <input
                      type="text"
                      placeholder="Search by Unit No."
                      value={searchInput}
                      onChange={handleSearchChange}
                      style={{
                        flex: 1,
                        padding: "10px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        fontSize: "13.5px",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleSearchSubmit}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "10px",
                        border: "none",
                        background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        color: "#ffffff",
                        fontWeight: "700",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>

                {(searchQuery || selectedProject) && (
                  <button
                    type="button"
                    onClick={handleClearFilters}
                    style={{
                      padding: "10px 20px",
                      borderRadius: "10px",
                      border: "1.5px solid #e2e8f0",
                      background: "#ffffff",
                      color: "#64748b",
                      fontWeight: "700",
                      cursor: "pointer",
                      height: "42px",
                    }}
                  >
                    Clear
                  </button>
                )}
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Project Name",
                      "Block Name",
                      "Unit No.",
                      "Road Size",
                      "Unit Type",
                      "Facing",
                      "Unit Size",
                      "Unit Area SQMT",
                      "Unit Area(SQYD)",
                      "PLC (%)",
                      "Unit Rate",
                      "Unit Price",
                      "Date",
                      "Status",
                      "Actions",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {plots?.length > 0 ? (
                    plots.map((plot, index) => (
                      <tr
                        key={plot.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + index + 1}
                        </td>
                        <td style={cellDark}>{plot.project_name}</td>
                        <td style={cellDark}>{plot.block_name}</td>
                        <td style={cellText}>{plot.plot_shop_villa_no}</td>
                        <td style={cellGray}>{plot.road_size || "NA"}</td>
                        <td style={cellGray}>{plot.unit_type || "NA"}</td>
                        <td style={cellGray}>{plot.facing || "NA"}</td>
                        <td style={cellGray}>{plot.dimension || "0.00"}</td>
                        <td style={cellGray}>{plot.unit_area_sqmt || "0.00"}</td>
                        <td style={cellGray}>{plot.area_sqyd || "0.00"}</td>
                        <td style={cellGray}>{plot.plc_percentage || "0.00"}</td>
                        <td style={cellGray}>{plot.rate || "0.00"}</td>
                        <td style={cellGray}>{plot.unit_price || "0.00"}</td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {plot.date
                            ? (() => {
                                const [day, month, year] = plot.date.split("-");
                                const formattedDate = new Date(
                                  `${year}-${month}-${day}`
                                );
                                return !isNaN(formattedDate)
                                  ? formattedDate.toLocaleDateString("en-GB")
                                  : "NA";
                              })()
                            : "NA"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 12px",
                              borderRadius: "20px",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              background:
                                plot.status === "available"
                                  ? "#e7f9eb"
                                  : "#feeaeb",
                              color:
                                plot.status === "available"
                                  ? "#059669"
                                  : "#dc2626",
                              textTransform: "capitalize",
                            }}
                          >
                            {plot.status}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              data-bs-boundary="viewport"
                              data-bs-popper-config='{"strategy":"fixed"}'
                              aria-expanded="false"
                              style={{
                                background: "#f8fafc",
                                border: "1.5px solid #e2e8f0",
                                borderRadius: "8px",
                                width: "36px",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1e5799",
                                padding: 0,
                              }}
                            >
                              <BsThreeDots size={18} />
                            </button>
                            <ul
                              className="dropdown-menu"
                              style={{
                                zIndex: 9999,
                                borderRadius: "14px",
                                border: "none",
                                padding: "8px",
                                boxShadow:
                                  "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                minWidth: "230px",
                                marginTop: "8px",
                                background: "#ffffff",
                              }}
                            >
                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleViewPlot(plot.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e8f1fb";
                                    e.currentTarget.style.transform = "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.transform = "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e8f1fb", "#1e5799")}>
                                    <FaEye size={13} />
                                  </span>
                                  View Details
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleEditPlot(plot.id)}
                                  style={dropdownItem}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f9eb";
                                    e.currentTarget.style.transform = "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.transform = "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#e7f9eb", "#059669")}>
                                    <FaEdit size={13} />
                                  </span>
                                  Edit Unit
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() =>
                                    handleStatusUpdate(plot.id, plot.status)
                                  }
                                  style={{
                                    ...dropdownItem,
                                    color:
                                      plot.status === "available"
                                        ? "#dc2626"
                                        : "#059669",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      plot.status === "available"
                                        ? "#feeaeb"
                                        : "#e7f9eb";
                                    e.currentTarget.style.transform = "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.transform = "translateX(0)";
                                  }}
                                >
                                  <span
                                    style={iconBadge(
                                      plot.status === "available"
                                        ? "#feeaeb"
                                        : "#e7f9eb",
                                      plot.status === "available"
                                        ? "#dc2626"
                                        : "#059669"
                                    )}
                                  >
                                    {plot.status === "available" ? (
                                      <MdAirplanemodeInactive size={13} />
                                    ) : (
                                      <MdAirplanemodeActive size={13} />
                                    )}
                                  </span>
                                  {plot.status === "available"
                                    ? "Mark Sold"
                                    : "Mark Available"}
                                </button>
                              </li>

                              <li>
                                <hr
                                  style={{
                                    margin: "6px 8px",
                                    border: "none",
                                    borderTop: "1.5px dashed #e2e8f0",
                                  }}
                                />
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex align-items-center"
                                  onClick={() => handleDeletePlot(plot.id)}
                                  style={{ ...dropdownItem, color: "#dc2626" }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#feeaeb";
                                    e.currentTarget.style.transform = "translateX(3px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.transform = "translateX(0)";
                                  }}
                                >
                                  <span style={iconBadge("#feeaeb", "#dc2626")}>
                                    <RiDeleteBin5Fill size={13} />
                                  </span>
                                  Delete Unit
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="16"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        {searchQuery || selectedProject
                          ? "📭 No units found with current filters."
                          : "📭 No units found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }

                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 VIEW MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size="lg"
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            📋 Unit Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          {selectedPlot && (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                {[
                  ["Project Name", selectedPlot.project_name, "Block Name", selectedPlot.block_name],
                  ["Unit No.", selectedPlot.plot_shop_villa_no, "Road Size", selectedPlot.road_size],
                  ["Unit Type", selectedPlot.unit_type, "Facing", selectedPlot.facing],
                  ["Unit Size", selectedPlot.dimension, "Unit Area SQMT", selectedPlot.unit_area_sqmt],
                  ["Unit Area(SQYD)", selectedPlot.area_sqyd, "PLC Percentage", selectedPlot.plc_percentage],
                  ["Unit Rate", selectedPlot.rate, "Unit Price", selectedPlot.unit_price],
                  [
                    "Date",
                    selectedPlot.date && !isNaN(new Date(selectedPlot.date).getTime())
                      ? new Date(selectedPlot.date).toLocaleDateString("en-GB")
                      : "NA",
                    "Status",
                    selectedPlot.status,
                  ],
                ].map((row, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={viewLabel}>{row[0]}:</td>
                    <td style={viewValue}>{row[1] || "N/A"}</td>
                    <td style={viewLabel}>{row[2]}:</td>
                    <td style={viewValue}>
                      {row[2] === "Status" ? (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "11.5px",
                            fontWeight: "700",
                            background:
                              row[3] === "available" ? "#e7f9eb" : "#feeaeb",
                            color:
                              row[3] === "available" ? "#059669" : "#dc2626",
                            textTransform: "capitalize",
                          }}
                        >
                          {row[3]}
                        </span>
                      ) : (
                        row[3] || "N/A"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1.5px solid #e2e8f0" }}>
          <Button
            variant="secondary"
            onClick={handleCloseViewModal}
            style={{ borderRadius: "10px", fontWeight: "700", padding: "8px 24px" }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={showEditModal}
        size="lg"
        onHide={handleCloseEditModal}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Unit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "24px", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Form onSubmit={handleUpdatePlot}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editProjectId">
                  <Form.Label style={labelStyle}>Project Name</Form.Label>
                  <Form.Select
                    name="project_id"
                    value={editFormData.project_id}
                    onChange={handleEditFormChange}
                    disabled={loadingDropdowns || projectsForEdit.length === 0}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select a Project</option>
                    {projectsForEdit.map((project) => (
                      <option key={project.id} value={project.id}>
                        {project.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editBlockId">
                  <Form.Label style={labelStyle}>Block Name</Form.Label>
                  <Form.Select
                    name="block_id"
                    value={editFormData.block_id}
                    onChange={handleEditFormChange}
                    disabled={
                      !editFormData.project_id ||
                      loadingDropdowns ||
                      blocksForEdit.length === 0
                    }
                    style={inputStyle}
                  >
                    <option value="">Select a Block</option>
                    {blocksForEdit.map((block) => (
                      <option key={block.id} value={block.id}>
                        {block.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="displayProjectName">
                  <Form.Label style={labelStyle}>Selected Project Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="project_name"
                    value={editFormData.project_name}
                    readOnly
                    disabled
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="displayBlockName">
                  <Form.Label style={labelStyle}>Selected Block Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="block_name"
                    value={editFormData.block_name}
                    readOnly
                    disabled
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editPlotShopVillaNo">
                  <Form.Label style={labelStyle}>Unit/Shop/Villa No.</Form.Label>
                  <Form.Control
                    type="text"
                    name="plot_shop_villa_no"
                    value={editFormData.plot_shop_villa_no}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editPlotSize">
                  <Form.Label style={labelStyle}>Dimension</Form.Label>
                  <Form.Control
                    type="text"
                    name="plot_size"
                    value={editFormData.plot_size}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editPlotSqYd">
                  <Form.Label style={labelStyle}>Area Sq. yard.</Form.Label>
                  <Form.Control
                    type="number"
                    name="plot_sqyd"
                    value={editFormData.plot_sqyd}
                    onChange={handleEditFormChange}
                    required
                    min="0"
                    step="0.01"
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editPlotRate">
                  <Form.Label style={labelStyle}>Rate</Form.Label>
                  <Form.Control
                    type="number"
                    name="plot_rate"
                    value={editFormData.plot_rate}
                    onChange={handleEditFormChange}
                    required
                    min="0"
                    step="0.01"
                    style={inputStyle}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editResgistryPatta">
                  <Form.Label style={labelStyle}>Document Type</Form.Label>
                  <Form.Select
                    name="resgistry_patta"
                    value={editFormData.resgistry_patta}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  >
                    <option value="">Select Option</option>
                    <option value="registry">Registry</option>
                    <option value="patta">Patta</option>
                    <option value="registrywithpatta">Registry with Patta</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="editStatus">
                  <Form.Label style={labelStyle}>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={editFormData.status}
                    onChange={handleEditFormChange}
                    required
                    style={inputStyle}
                  >
                    <option value="available">✅ Available</option>
                    <option value="sold">⛔ Sold</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="editPlotAddress">
                  <Form.Label style={labelStyle}>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="plot_address"
                    value={editFormData.plot_address}
                    onChange={handleEditFormChange}
                    required
                    style={{ ...inputStyle, padding: "10px 14px", resize: "vertical" }}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={loading}
                  style={{
                    borderRadius: "10px",
                    fontWeight: "700",
                    padding: "12px",
                    background: loading
                      ? "#cbd5e1"
                      : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    border: "none",
                    boxShadow: loading
                      ? "none"
                      : "0 6px 18px rgba(30, 87, 153, 0.3)",
                  }}
                >
                  {loading ? "Updating..." : "Update Unit"}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 MESSAGE MODAL — Solid #1e5799 */}
      {/* ═══════════════════════════════════════════ */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
              }}
            >
              <div
                style={{
                  background: "#1e5799",
                  color: "#ffffff",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 0, fontWeight: "800", fontSize: "16px" }}>
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ padding: "24px", fontSize: "14px", color: "#334155" }}
              >
                {messageModalContent.text}
              </div>
              <div
                className="modal-footer"
                style={{
                  borderTop: "1.5px solid #e2e8f0",
                  padding: "16px 24px",
                  gap: "10px",
                }}
              >
                {messageModalContent.confirmAction ? (
                  <>
                    <button
                      type="button"
                      onClick={closeCustomMessageModal}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#1e5799",
                        color: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "700",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      Confirm
                    </button>
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={closeCustomMessageModal}
                    style={{
                      padding: "10px 22px",
                      borderRadius: "10px",
                      border: "none",
                      background: "#1e5799",
                      color: "#ffffff",
                      fontSize: "13px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                    }}
                  >
                    OK
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = { padding: "12px", fontWeight: "600", color: "#1e5799" };

const viewLabel = {
  padding: "10px 12px",
  fontWeight: "700",
  color: "#1e5799",
  fontSize: "12.5px",
  width: "20%",
  background: "#f8fafc",
};

const viewValue = {
  padding: "10px 12px",
  color: "#334155",
  fontSize: "13px",
  fontWeight: "500",
  width: "30%",
};

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default AllPlotList;
